import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "./Portfolio.css";
import comforty from "../assets/projects/comforty.png";
import tasks from "../assets/projects/daily-task.png";
import hooBank from "../assets/projects/hooBank.png";
import nativeEcommerce from "../assets/projects/native-e-commerce.png";
import weatherApp from "../assets/projects/weather-app.png";
import wepStore from "../assets/projects/wep_store.png";
import adminDashboard from "../assets/projects/admin-dashboard.png";
import agriculturalConsulting from "../assets/projects/agriculturalConsulting.png";
import NEWLOOKCMS from "../assets/projects/NEWLOOK CMS.png";
import MovieApp from "../assets/projects/Movie App.png";
import StorePlatform from "../assets/projects/Store Platform.png";
import CharityPlatform from "../assets/projects/Charity Platform.png";

const projects = [
  {
    title: "Comforty",
    category: "HTML & CSS",
    description:
      "Comforty is a sleek, modern template perfect for furniture and decor stores. It offers easy navigation and attractive product displays for a smooth shopping experience on any device.",
    image: comforty,
    demoLink: "https://depi-comforty.netlify.app/",
    codeLink: "",
  },
  {
    title: "hooBank",
    category: "HTML & CSS",
    description:
      "HooBank is a stylish landing page for advanced financial services with a dark, professional look. It uses Bootstrap and Font Awesome to offer credit card options, business tools, and smooth app integration.",
    image: hooBank,
    demoLink: "https://depi-hoobank.netlify.app/",
    codeLink: "",
  },
  {
    title: "native E-Commerce",
    category: "HTML & CSS",
    description:
      "A modern, responsive online store with pages for shopping, blog, about, contact, and cart. It includes promo banners, an interactive cart, a contact form with map, a blog, and newsletter signup to keep customers engaged.",
    image: nativeEcommerce,
    demoLink: "https://native-ecommerce.netlify.app/",
    codeLink: "",
  },
  {
    title: "Smart agricultural consulting",
    category: "JavaScript",
    description:
      "A simple online platform connecting farmers with agri-experts for advice, tips, and quick consultations. It includes easy-to-understand articles, real reviews, and works smoothly on all devices.",
    image: agriculturalConsulting,
    demoLink: "https://agricultural-consulting.netlify.app/",
    codeLink: "",
  },
  {
    title: "To Do List",
    category: "JavaScript",
    description:
      "A simple task manager that helps you organize work and life with easy drag & drop, task stages, and filters. It saves your tasks automatically, works offline, and fits all devices.",
    image: tasks,
    demoLink: "https://to-do-ta2k.netlify.app/",
    codeLink: "",
  },
  {
    title: "Weather App",
    category: "JavaScript",
    description:
      "A weather app that fetches real-time data using OpenWeatherMap API. Users can search for cities, view temperature, humidity, and wind speed, with autocomplete suggestions. Features a clean, animated UI with a responsive card layout.",
    image: weatherApp,
    demoLink: "https://ahmedel-refa3y.github.io/weather-app/",
    codeLink: "",
  },
  {
    title: "NEWLOOK CMS",
    category: "JavaScript",
    description:
      "NEWLOOK CMS helps eyewear salons easily manage customers, sales, and prescriptions with a simple Arabic interface. It tracks payments, generates reports, and saves data locally—no server required.",
    image: NEWLOOKCMS,
    demoLink: "https://crud-msystem.netlify.app/",
    codeLink: "",
  },
  {
    title: "Movie Discovery App",
    category: "React",
    description:
      "A React app for discovering movies with filters, detailed info, and smooth navigation. It uses a movie API plus Bootstrap for a clean, interactive experience.",
    image: MovieApp,
    demoLink: "https://movies-discovry-app.netlify.app/",
    codeLink: "",
  },
  {
    title: "Admin Dashboard",
    category: "React",
    description:
      "The `package.json` outlines a React-based admin dashboard project using Material-UI and Recharts, configured for deployment to GitHub Pages. It includes dependencies for UI components, routing, and data visualization.",
    image: adminDashboard,
    demoLink: "https://ahmedel-refa3y.github.io/Admin-Dashboard/",
    codeLink: "https://github.com/AhmedEl-Refa3y/Admin-Dashboard",
  },
  {
    title: "Store Platform",
    category: "JavaScript",
    description:
      "A smart platform for luxury perfume shops and buyers with easy management, smooth browsing, and secure checkout. It works great on all devices and offers a stylish, simple shopping experience.",
    image: StorePlatform,
    demoLink: "https://full-e-commerce-js.netlify.app/",
    codeLink: "",
  },
  {
    title: "Charity Platform",
    category: "HTML & CSS",
    description:
      "A simple online platform to help people donate easily to causes like relief, education, and healthcare worldwide. It’s user-friendly, shows clear projects, and supports multiple payment methods.",
    image: CharityPlatform,
    demoLink: "https://charity-website25.netlify.app/",
    codeLink: "",
  },
];

const Portfolio = () => {
  const [activeFilter, setActiveFilter] = useState("All Projects");

  const filteredProjects =
    activeFilter === "All Projects"
      ? projects
      : projects.filter((project) => project.category === activeFilter);

  const handleFilterClick = (category) => {
    setActiveFilter(category);
  };

  return (
    <div className="portfolio-container" id="portfolio">
      <motion.h2
        className="section__title"
        initial={{ opacity: 0, y: -50 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        Projects
      </motion.h2>
      <div className="projects-container">
        <aside className="filters">
          {["All Projects", "HTML & CSS", "JavaScript", "React"].map(
            (filter) => (
              <button
                key={filter}
                className={`filter-button ${
                  activeFilter === filter ? "active" : ""
                }`}
                onClick={() => handleFilterClick(filter)}
              >
                {filter}
              </button>
            )
          )}
        </aside>
        <motion.div layout className="projects">
          <AnimatePresence>
            {filteredProjects.map((project, index) => (
              <motion.div
                className="project-card"
                key={index}
                layout
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.4 }}
              >
                <img src={project.image} alt={project.title} />
                <div className="" style={{ padding: "10px" }}>
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  <div className="card-links">
                    <a
                      href={project.demoLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-link"></i>
                    </a>
                    <a
                      href={project.codeLink}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <i className="fa fa-code"></i>
                    </a>
                  </div>
                </div>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
};

export default Portfolio;
